@if (initialized && dto) {

    <!-- ==================== Tab: Übersicht ==================== -->
    @if (activeNavigationItems?.action == 'overview') {
        <div class="p-3">
            <mvs-crud-object-generic
                [objectType]="'uf.UfFlowTypeStep'"
                [objectId]="objectIdentifier.objectId"
                (onChangedObject)="refreshObject(false)">
            </mvs-crud-object-generic>
        </div>
    }

    <!-- ==================== Tab: Aktivitäten ==================== -->
    @if (activeNavigationItems?.action == 'activities') {
        <div class="p-3">
            @if (activitiesWidget) {
                <mvs-widget [widgetData]="activitiesWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Tab: Aktionen ==================== -->
    @if (activeNavigationItems?.action == 'actions') {
        <div class="p-3">
            @if (actionsWidget) {
                <mvs-widget [widgetData]="actionsWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Tab: Themenregeln ==================== -->
    @if (activeNavigationItems?.action == 'topicRules') {
        <div class="p-3">
            @if (topicRulesWidget) {
                <mvs-widget [widgetData]="topicRulesWidget"></mvs-widget>
            }
        </div>
    }

}
